export default {"src":"/_next/static/media/credit-card.212878e6.svg","height":16,"width":16};